import { minimumWidth, pxToRem, styled } from '@feast-it/ui/light';
import { css } from '@emotion/core';

import { TrustpilotReviewsWidget } from '../../TrustpilotReviewsWidget';

export const ImageContainer = styled.div`
  ${({ theme }) => `
    position: relative;
    width: ${pxToRem(320)};
    height: ${pxToRem(240)};

    ${minimumWidth(theme.breakpoints.small)} {
     min-width: ${pxToRem(332)};
     height: ${pxToRem(360)};
    }
    ${minimumWidth(theme.breakpoints.large)} {
     min-width: ${pxToRem(400)};
     height: ${pxToRem(408)};
    }
  `};
`;

export const TopIllustrationWrapper = styled.div`
  ${({ theme }) => `
    position: absolute;
    right: -${theme.spacing[10]};
    top: ${pxToRem(21)};

    ${minimumWidth(theme.breakpoints.small)} {
      top: -${theme.spacing[12]};
      right: ${pxToRem(-137)};
    }

    ${minimumWidth(theme.breakpoints.large)} {
      top: ${pxToRem(-102)};
      right: ${pxToRem(-350)};
    }
  `}
`;

export const BottomIllustrationWrapper = styled.div`
  ${({ theme }) => `
    position: absolute;
    bottom: ${pxToRem(-87)};
    left: ${pxToRem(-83)};

    ${minimumWidth(theme.breakpoints.small)} {
      bottom: ${pxToRem(-68)};
      left: ${pxToRem(13)};
    }
  `}
`;

export const HeroImage = styled.div<{ width: number; height: number }>`
  ${({ theme, width, height }) => `
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    width: ${pxToRem(width)};
    aspect-ratio: ${width} / ${height};
    position: absolute;
    top: ${pxToRem(45)};
    left: 50%;
    rotate: 5deg;
    transform: translateX(-50%);
    overflow: hidden;
    border-radius: ${theme.spacing[2]};

    ${minimumWidth(theme.breakpoints.small)} {
      top: unset;
      left: 12.5%;
      bottom: 50%;
      transform: translateY(50%);
    }
  `};
`;

export const TrustpilotStyledWidget = styled(TrustpilotReviewsWidget)(
  ({ theme }) => css`
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    z-index: 3;
    iframe {
      height: ${pxToRem(24)} !important;
    }

    ${minimumWidth(theme.breakpoints.small)} {
      top: unset;
      right: unset;
      bottom: 0;
      left: 0;
      iframe {
        height: ${pxToRem(64)} !important;
      }
    }

    ${minimumWidth(theme.breakpoints.large)} {
      iframe {
        height: ${pxToRem(24)} !important;
      }
    }
  `
);
